import React from 'react'

const Tr = (props) => {

    const ranking = props.ranking;

    return (
    <>
        <tr>
            <td>{ranking.ranking}</td>
            <td>{ranking.name}</td>
            <td>{Number(ranking.count).toLocaleString('ja-JP')}</td>
            <td>{Number(ranking.once_count).toLocaleString('ja-JP')}</td>
            <td>{Number(ranking.multi_count).toLocaleString('ja-JP')}</td>
            <td>{Number(ranking.stock_count).toLocaleString('ja-JP')}</td>
            <td>{Number(ranking.user_count).toLocaleString('ja-JP')}</td>
        </tr>
    </>
    )
}

export default Tr